<section class="experience-section" id="app-preview">
  <div class="container">

    <div class="section-head">
      <h2>Experience <span class="heading-gradient">DropAddy</span></h2>
      <p>Browse exclusive events, chat with hosts, and get instant access with<br />our countdown timer feature</p>
    </div>

    <div class="preview-grid">

      <!-- Event Feed -->
      <div class="preview-card">
        <div class="preview-bg left">
          <img src="assets/images/exp-left.svg" class="phone-screenshot" alt="Event Feed" />
        </div>
        <div class="preview-label">
          <h4 class="heading-gradient">Event Feed</h4>
          <p>Discover parties happening near you</p>
        </div>
      </div>

      <!-- Real-Time Chat -->
      <div class="preview-card">
        <div class="preview-bg right">
          <img src="assets/images/exp-right.svg" class="phone-screenshot" alt="Real-Time Chat" />
        </div>
        <div class="preview-label">
          <h4 class="heading-gradient">Real-Time Chat</h4>
          <p>Connect with hosts and attendees</p>
        </div>
      </div>

    </div>
  </div>
</section>
